var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6963 12.5L24.4057 4.79064C25.1981 3.9982 25.1981 2.71343 24.4057 1.92098L23.079 0.594331C22.2866 -0.19811 21.0018 -0.19811 20.2094 0.594331L12.5 8.30369L4.79064 0.594331C3.9982 -0.19811 2.71343 -0.19811 1.92098 0.594331L0.594331 1.92098C-0.19811 2.71343 -0.19811 3.9982 0.594331 4.79064L8.30369 12.5L0.594331 20.2094C-0.19811 21.0018 -0.19811 22.2866 0.594331 23.079L1.92098 24.4057C2.71343 25.1981 3.9982 25.1981 4.79064 24.4057L12.5 16.6963L20.2094 24.4057C21.0018 25.1981 22.2866 25.1981 23.079 24.4057L24.4057 23.079C25.1981 22.2866 25.1981 21.0018 24.4057 20.2094L16.6963 12.5Z",
    fill: "#D11C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.c87ddf88157d7db4d50e0e20a5428f96.svg";
export { ForwardRef as ReactComponent };